import S from "../../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import W from "../../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import { isDOM as We } from "../../../../rc-util/es/Dom/findDOMNode.mjs";
import _e from "../../../../rc-util/es/Dom/isVisible.mjs";
import je from "../../../../rc-util/es/hooks/useEvent.mjs";
import Et from "../../../../rc-util/es/hooks/useLayoutEffect.mjs";
import * as Q from "react";
import { collectScroller as He, getWin as Ne, getVisibleArea as It, toNum as St } from "../util.mjs";
function Wt(t) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = "".concat(a), s = o.match(/^(.*)\%$/);
  return s ? t * (parseFloat(s[1]) / 100) : parseFloat(o);
}
function _t(t, a) {
  var o = a || [], s = W(o, 2), c = s[0], g = s[1];
  return [Wt(t.width, c), Wt(t.height, g)];
}
function jt() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [t[0], t[1]];
}
function C(t, a) {
  var o = a[0], s = a[1], c, g;
  return o === "t" ? g = t.y : o === "b" ? g = t.y + t.height : g = t.y + t.height / 2, s === "l" ? c = t.x : s === "r" ? c = t.x + t.width : c = t.x + t.width / 2, {
    x: c,
    y: g
  };
}
function d(t, a) {
  var o = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return t.map(function(s, c) {
    return c === a ? o[s] || "c" : s;
  }).join("");
}
function De(t, a, o, s, c, g, rt) {
  var Ht = Q.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: c[s] || {}
  }), ot = W(Ht, 2), p = ot[0], nt = ot[1], G = Q.useRef(0), it = Q.useMemo(function() {
    return a ? He(a) : [];
  }, [a]), l = Q.useRef({}), Nt = function() {
    l.current = {};
  };
  t || Nt();
  var Ft = je(function() {
    if (a && o && t) {
      let h = function(I, Je) {
        var K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : r, Ut = u.x + I, Vt = u.y + Je, Pe = Ut + X, Ue = Vt + Y, Ve = Math.max(Ut, K.left), Ee = Math.max(Vt, K.top), Ie = Math.min(Pe, K.right), Se = Math.min(Ue, K.bottom);
        return Math.max(0, (Ie - Ve) * (Se - Ee));
      }, Pt = function() {
        A = u.y + i, k = A + Y, L = u.x + n, Z = L + X;
      };
      var f = a, kt = f.style.left, Zt = f.style.top, Kt = f.ownerDocument, Qt = Ne(f), b = S(S({}, c[s]), g);
      f.style.left = "0", f.style.top = "0";
      var e;
      if (Array.isArray(o))
        e = {
          x: o[0],
          y: o[1],
          width: 0,
          height: 0
        };
      else {
        var _ = o.getBoundingClientRect();
        e = {
          x: _.x,
          y: _.y,
          width: _.width,
          height: _.height
        };
      }
      var u = f.getBoundingClientRect(), st = Qt.getComputedStyle(f), Gt = st.width, Dt = st.height, w = Kt.documentElement, $t = w.clientWidth, te = w.clientHeight, ee = w.scrollWidth, re = w.scrollHeight, ft = w.scrollTop, lt = w.scrollLeft, Y = u.height, X = u.width, O = e.height, R = e.width, oe = {
        left: 0,
        top: 0,
        right: $t,
        bottom: te
      }, ne = {
        left: -lt,
        top: -ft,
        right: ee - lt,
        bottom: re - ft
      }, B = b.htmlRegion, ut = "visible", ct = "visibleFirst";
      B !== "scroll" && B !== ct && (B = ut);
      var q = B === ct, ie = It(ne, it), x = It(oe, it), r = B === ut ? x : ie, j = q ? x : r;
      f.style.left = kt, f.style.top = Zt;
      var H = St(Math.round(X / parseFloat(Gt) * 1e3) / 1e3), N = St(Math.round(Y / parseFloat(Dt) * 1e3) / 1e3);
      if (H === 0 || N === 0 || We(o) && !_e(o))
        return;
      var ae = b.offset, se = b.targetOffset, fe = _t(u, ae), mt = W(fe, 2), D = mt[0], $ = mt[1], le = _t(e, se), ht = W(le, 2), ue = ht[0], ce = ht[1];
      e.x -= ue, e.y -= ce;
      var me = b.points || [], gt = W(me, 2), he = gt[0], ge = gt[1], v = jt(ge), m = jt(he), pt = C(e, v), yt = C(u, m), M = S({}, b), n = pt.x - yt.x + D, i = pt.y - yt.y + $, y = h(n, i), F = h(n, i, x), dt = C(e, ["t", "l"]), xt = C(u, ["t", "l"]), vt = C(e, ["b", "r"]), bt = C(u, ["b", "r"]), T = b.overflow || {}, pe = T.adjustX, ye = T.adjustY, wt = T.shiftX, Yt = T.shiftY, Xt = function(I) {
        return typeof I == "boolean" ? I : I >= 0;
      }, A, k, L, Z;
      Pt();
      var Mt = Xt(ye), Ct = m[0] === v[0];
      if (Mt && m[0] === "t" && (k > j.bottom || l.current.bt)) {
        var z = i;
        Ct ? z -= Y - O : z = dt.y - bt.y - $;
        var Ot = h(n, z), de = h(n, z, x);
        Ot > y || Ot === y && (!q || // Choose recommend one
        de >= F) ? (l.current.bt = !0, i = z, M.points = [d(m, 0), d(v, 0)]) : l.current.bt = !1;
      }
      if (Mt && m[0] === "b" && (A < j.top || l.current.tb)) {
        var J = i;
        Ct ? J += Y - O : J = vt.y - xt.y - $;
        var Rt = h(n, J), xe = h(n, J, x);
        Rt > y || Rt === y && (!q || // Choose recommend one
        xe >= F) ? (l.current.tb = !0, i = J, M.points = [d(m, 0), d(v, 0)]) : l.current.tb = !1;
      }
      var Bt = Xt(pe), qt = m[1] === v[1];
      if (Bt && m[1] === "l" && (Z > j.right || l.current.rl)) {
        var P = n;
        qt ? P -= X - R : P = dt.x - bt.x - D;
        var At = h(P, i), ve = h(P, i, x);
        At > y || At === y && (!q || // Choose recommend one
        ve >= F) ? (l.current.rl = !0, n = P, M.points = [d(m, 1), d(v, 1)]) : l.current.rl = !1;
      }
      if (Bt && m[1] === "r" && (L < j.left || l.current.lr)) {
        var U = n;
        qt ? U += X - R : U = vt.x - xt.x - D;
        var Lt = h(U, i), be = h(U, i, x);
        Lt > y || Lt === y && (!q || // Choose recommend one
        be >= F) ? (l.current.lr = !0, n = U, M.points = [d(m, 1), d(v, 1)]) : l.current.lr = !1;
      }
      Pt();
      var V = wt === !0 ? 0 : wt;
      typeof V == "number" && (L < r.left && (n -= L - r.left, e.x + R < r.left + V && (n += e.x - r.left + R - V)), Z > r.right && (n -= Z - r.right, e.x > r.right - V && (n += e.x - r.right + V)));
      var E = Yt === !0 ? 0 : Yt;
      typeof E == "number" && (A < r.top && (i -= A - r.top, e.y + O < r.top + E && (i += e.y - r.top + O - E)), k > r.bottom && (i -= k - r.bottom, e.y > r.bottom - E && (i += e.y - r.bottom + E)));
      var tt = u.x + n, we = tt + X, et = u.y + i, Ye = et + Y, zt = e.x, Xe = zt + R, Jt = e.y, Me = Jt + O, Ce = Math.max(tt, zt), Oe = Math.min(we, Xe), Re = (Ce + Oe) / 2, Be = Re - tt, qe = Math.max(et, Jt), Ae = Math.min(Ye, Me), Le = (qe + Ae) / 2, ze = Le - et;
      rt == null || rt(a, M), nt({
        ready: !0,
        offsetX: n / H,
        offsetY: i / N,
        arrowX: Be / H,
        arrowY: ze / N,
        scaleX: H,
        scaleY: N,
        align: M
      });
    }
  }), Tt = function() {
    G.current += 1;
    var f = G.current;
    Promise.resolve().then(function() {
      G.current === f && Ft();
    });
  }, at = function() {
    nt(function(f) {
      return S(S({}, f), {}, {
        ready: !1
      });
    });
  };
  return Et(at, [s]), Et(function() {
    t || at();
  }, [t]), [p.ready, p.offsetX, p.offsetY, p.arrowX, p.arrowY, p.scaleX, p.scaleY, p.align, Tt];
}
export {
  De as default
};
//# sourceMappingURL=useAlign.mjs.map
